import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '1000px'
    },
    height: {
      type: String,
      default: '350px'
    },
    top: {
      type: String,
      default: '51px'
    },
    left: {
      type: String,
      default: '-114px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {// setTimeout(() => {
    // 	this.initBarChart()
    // }, 1000)
    // this.$nextTick(() => {})
  },
  methods: {
    initBarChart: function initBarChart(arr1, arr2) {
      //	得到仪表盘
      //非本人所创,借鉴各位前辈项目改善完成,仅供参考
      var highlight = '#03b7c9';
      var demoData = [{
        name: '同比去年' + (arr1.someNum - 0 >= 0 ? '上升' : '下降') + Math.abs(arr1.someNum - 0),
        value: arr1.nowNum,
        data: 'PM2.5安全天数',
        unit: '天',
        // unit: 'μg/m³',
        pos: ['25%', '40%'],
        range: [0, 100],
        YS: [[0.4, '#119eff'], [0.5, '#30da74'], [1, '#f3390d']]
      }, {
        name: '同比去年' + (arr2.someNum - 0 >= 0 ? '上升' : '下降') + Math.abs(arr2.someNum - 0),
        value: arr2.nowNum,
        unit: '天',
        data: '重污染天数',
        pos: ['75%', '40%'],
        range: [0, 100],
        splitNum: 10,
        YS: [[0.3, ' #119eff'], [0.8, '#30da74'], [1, '#f3390d']]
      }];
      var option = {
        tooltip: {
          formatter: "{c}"
        },
        // backgroundColor: '#00162d',
        series: function () {
          var result = [];
          demoData.forEach(function (item) {
            result.push( // 外围刻度
            {
              type: 'gauge',
              center: item.pos,
              radius: '50%',
              // 1行2个
              splitNumber: item.splitNum || 10,
              min: item.range[0],
              max: item.range[1],
              startAngle: 225,
              endAngle: -45,
              axisLine: {
                show: true,
                lineStyle: {
                  width: 2,
                  shadowBlur: 0,
                  color: [[1, highlight]]
                }
              },
              axisTick: {
                show: true,
                lineStyle: {
                  color: highlight,
                  width: 1
                },
                length: -5,
                splitNumber: 10
              },
              splitLine: {
                show: true,
                length: -10,
                lineStyle: {
                  color: highlight
                }
              },
              axisLabel: {
                distance: -18,
                textStyle: {
                  color: highlight,
                  fontSize: '10'
                }
              },
              pointer: {
                show: 0
              },
              detail: {
                show: true,
                offsetCenter: [0, '0%'],
                fontSize: 18,
                color: '#4be4de',
                formatter: function formatter(value) {
                  return item.value + '\n\n\n' + item.unit;
                }
              }
            }, {
              name: '速度',
              type: 'gauge',
              center: item.pos,
              splitNumber: item.splitNum || 10,
              min: item.range[0],
              max: item.range[1],
              radius: '45%',
              axisLine: {
                // 坐标轴线
                show: false,
                lineStyle: {
                  // 属性lineStyle控制线条样式
                  color: item.YS,
                  shadowColor: "#ccc",
                  shadowBlur: 25,
                  width: 0
                }
              },
              axisLabel: {
                show: false
              },
              axisTick: {
                // 坐标轴小标记
                // show: false,
                length: 20,
                // 属性length控制线长
                lineStyle: {
                  // 属性lineStyle控制线条样式
                  color: 'auto',
                  width: 2
                }
              },
              splitLine: {
                // 分隔线
                show: false,
                length: 20,
                // 属性length控制线长
                lineStyle: {
                  // 属性lineStyle（详见lineStyle）控制线条样式
                  color: 'auto'
                }
              },
              title: {
                textStyle: {
                  // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                  fontWeight: 'bolder',
                  fontSize: 20,
                  fontStyle: 'italic'
                }
              },
              detail: {
                show: true,
                offsetCenter: [0, '110%'],
                textStyle: {
                  fontSize: 15,
                  color: '#fff'
                },
                lineHeight: 10,
                formatter: [item.data + '\n', '{name|' + item.name + item.unit + '}'].join('\n'),
                rich: {
                  name: {
                    fontSize: 16,
                    lineHeight: 16,
                    color: '#0dd1fb'
                  }
                }
              },
              data: [{
                value: item.value
              }],
              pointer: {
                width: 5
              }
            }, // 内侧指针、数值显示
            {
              name: item.name,
              type: 'gauge',
              center: item.pos,
              radius: '40%',
              startAngle: 225,
              endAngle: -45,
              min: item.range[0],
              max: item.range[1],
              axisLine: {
                show: true,
                lineStyle: {
                  width: 16,
                  color: [[1, 'rgba(75,228,255,.1)']]
                }
              },
              axisTick: {
                show: 0
              },
              splitLine: {
                show: 0
              },
              axisLabel: {
                show: 0
              },
              pointer: {
                show: true,
                length: '90%',
                width: 3
              },
              itemStyle: {
                //表盘指针的颜色
                color: 'rgba(255, 153, 0, 0.31)',
                borderColor: '#ff9900',
                borderWidth: 1
              },
              detail: {
                show: false,
                offsetCenter: [0, '100%'],
                textStyle: {
                  fontSize: 20,
                  color: '#00eff2'
                },
                formatter: ['{value} ', '{name|' + item.name + item.unit + '}'].join('\n'),
                rich: {
                  name: {
                    fontSize: 14,
                    lineHeight: 30,
                    color: '#00eff2'
                  }
                }
              },
              data: [{
                value: item.value
              }]
            });
          });
          return result;
        }()
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};